import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader } from 'shards-react';
import VChart from './VChart';

const MonthlyUsers = ({ title, users }) => {
  const { datasets, labels } = useMemo(() => {
    const sortedUsers = [...(users || [])].sort(
      (first, second) => String(first.period).localeCompare(String(second.period)),
    );
    const counts = sortedUsers.map(item => item.count);

    return {
      labels: sortedUsers.map(item => item.period),
      datasets: [
        {
          label: `Users (${counts.reduce((total, count) => total + count, 0)})`,
          fill: 'start',
          data: counts,
        },
      ],
    };
  }, [users]);

  return (
    <Card small className="h-100">
      <CardHeader className="border-bottom">
        <h6 className="m-0">{title}</h6>
      </CardHeader>
      <CardBody className="pt-0">
        {users.length > 0
          ? <VChart labels={labels} datasets={datasets} type="bar" height="240" />
          : <div className="text-center text-muted p-4">No monthly user data</div>}
      </CardBody>
    </Card>
  );
};

MonthlyUsers.propTypes = {
  title: PropTypes.string,
  users: PropTypes.array,
};

MonthlyUsers.defaultProps = {
  title: 'Users by month',
  users: [],
};

export default MonthlyUsers;
